// extracted by mini-css-extract-plugin
export default {"skeleton":"WideSkeleton_skeleton__2jxdu"};